module.exports = __webpack_public_path__ + "img/yishi12.3ed6a78f.jpg";